<template>
  <v-container fluid class="ma-0 pa-0">
		<Header />
    <v-col class="pa-0" id="main_content_maxwidthset" cols="12">
			<v-row class="ma-0 pa-2 pt-9">
				<v-col cols="1">
					{{'contractCd'}}
				</v-col>
        <v-col cols="4">
          <input id="input_grey" v-model="contractCd" placeholder="contractCd">
        </v-col>
        <v-col cols="1">
					{{'portNo'}}
				</v-col>
        <v-col cols="4">
          <input id="input_grey" v-model="portNo" placeholder="portNo">
        </v-col>
        <v-col cols="2" v-if="isClick">
          <v-switch class="ma-0 pa-0" v-model="isMuted" :label="isMuted? 'Unmute' : 'Mute'" inset>
            <template v-slot:label>
              <span style="color: white;">{{ isMuted ? 'Unmute' : 'Mute' }}</span>
            </template>
          </v-switch>
        </v-col>
        <v-col cols="2" v-if="!isClick">
          <v-btn width="100%" height="2.5rem" id="blue_btn" @click="complete">
            {{'start'}}
          </v-btn>
        </v-col>
			</v-row>
      <v-row class="ma-0 pa-2 pt-9">
        <v-col class="ma-0 pa-0" cols="12">
          <video id="myVideo" ref="videoElement" class="video-js vjs-default-skin vjs-big-play-centered vjs-current-time" controls autoplay></video>
        </v-col>
      </v-row>
		</v-col>
	</v-container>
</template>

<script>
import "video.js/dist/video-js.css";
import videojs from 'video.js';
import rtcViewer from '@/api/webrtc';

export default {
  data() {
    return {
      isClick: false,
      isMuted: false,
      player: null,
      contractCd: "TEST_BUB23400009",
      portNo: 1,
      infos: {
        key: null,
        channelName: null,
        clientId: String(Math.floor(Math.random() * 1000000)),
        sendVideo: false,
        sendAudio: false,
        forceTURN: false,
        wideScreen: false,
        openDataChannel: false,
        natTraversalDisabled: false,
        useTrickleICE: true,
      },
    }
  }, 
  methods: {
    startPlay() {
      const playerOptions = {
        language: 'ja',
        controls: true,
        liveui: true,
        autoplay: false,
        muted: false,
        playbackRates: [0.1, 0.25, 0.5, 1, 2, 3, 10],
        preload: 'auto',
        controlBar: {
          pictureInPictureToggle: false,
          progressControl: false,
          children: []
        },
      }
      const videoElement = this.$refs.videoElement;
      rtcViewer.startViewer(videoElement, this.infos);
      this.player = videojs(videoElement, playerOptions, () => {
        this.$refs.videoElement.play().then((value) => {
          console.log(value);
        }).catch((err) => {
          console.log(err);
        });
      });
    },
    complete() {
      this.isClick = true;
      const params = {};
      this.networkController.setCameraSignalingOn(params, this.contractCd, this.portNo)
        .then((res) => {
          if (res.status === 200)
            return this.networkController.getCameraInfo(params, this.contractCd, this.portNo);
        })
        .then((res) => {
          if (res.status === 200) {
            if (res.data.channelName) {
              this.infos.channelName = this.infos.key = res.data.channelName.replace('_TEST', '');
              this.startPlay();
            }
          }
        });
      },
  },
  mounted() {
  },
  watch: {
    isMuted: function() {
      if (this.player) {
        this.player.muted(this.isMuted);
      }
    }
  },
  beforeDestroy() {
    console.log(`Player Stop`);
    rtcViewer.stopViewer(this.infos);
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.hello {
  background-color: #bbbbbb;
}
.v-input--is-label-active label {
    color: red !important;
}
</style>
